import { Link as MuiLink } from '@mui/material';
import { forwardRef } from 'react';
import { Link as RemixLink } from 'react-router';
import type { LinkProps } from './Link.types';
import { isExternalLink } from './LinkUtils';

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, children, replace, preventScrollReset, state, ...props }, ref) => {
    // If the link is external, we can use the MUI Link component with the href prop
    if (isExternalLink(to)) {
      return (
        <MuiLink ref={ref} href={to} target="_blank" rel="noopener noreferrer" {...props}>
          {children}
        </MuiLink>
      );
    }

    // If the link is not external, we can assume it is internal and use the Remix Link component
    return (
      <MuiLink
        ref={ref}
        component={RemixLink}
        to={to}
        replace={replace}
        preventScrollReset={preventScrollReset}
        state={state}
        {...props}
      >
        {children}
      </MuiLink>
    );
  },
);

Link.displayName = 'Link';
